"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _badge = require("@design/ui/badge");
var _card = require("@design/ui/card");
var _collapsible = require("@design/ui/collapsible");
var _item = require("@design/ui/item");
var _spinner = require("@design/ui/spinner");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// The todo_list tool streams its JSON incrementally, so a chunk can be
// syntactically complete yet not have todos / status_summary populated. Treat
// such a not-yet-complete payload as "nothing to render" rather than letting it
// reach the widget body and throw.
var isValidTodoData = function isValidTodoData(data) {
  return Array.isArray(data === null || data === void 0 ? void 0 : data.todos) && (data === null || data === void 0 ? void 0 : data.status_summary) != null;
};
var getStatusIcon = function getStatusIcon(status) {
  switch (status) {
    case "pending":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CircleIcon, {
        className: "text-muted-foreground"
      });
    case "in_progress":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
        className: "text-muted-foreground"
      });
    case "completed":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
        className: "text-success"
      });
    case "cancelled":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CancelIcon, {
        className: "text-destructive"
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CircleIcon, {
        className: "text-muted-foreground"
      });
  }
};
var getHeaderTitle = function getHeaderTitle(todos, statusSummary, title) {
  // An explicit title (e.g. the review table's name) wins over the per-task headline.
  if (title) {
    return title;
  }

  // First pending or in-progress task is the "current" headline.
  var activeTask = todos.find(function (todo) {
    return todo.status === "in_progress" || todo.status === "pending";
  });
  if (activeTask) {
    return activeTask.content;
  }
  if (statusSummary.completed === statusSummary.total && statusSummary.total > 0) {
    return "All tasks completed";
  }
  return "Task List";
};
var getTasksRemaining = function getTasksRemaining(statusSummary) {
  return statusSummary.pending + statusSummary.in_progress;
};
var isAllTasksCompleted = function isAllTasksCompleted(statusSummary) {
  return statusSummary.completed === statusSummary.total && statusSummary.total > 0;
};

// Skip re-renders when the todo payload is unchanged — the chat stream emits
// the same widget data on many unrelated ticks.
var areTodoListWidgetPropsEqual = function areTodoListWidgetPropsEqual(prevProps, nextProps) {
  if (!isValidTodoData(prevProps.data) || !isValidTodoData(nextProps.data)) {
    return false;
  }
  if (prevProps.data.title !== nextProps.data.title) {
    return false;
  }
  var prevSummary = prevProps.data.status_summary;
  var nextSummary = nextProps.data.status_summary;
  if (prevSummary.total !== nextSummary.total || prevSummary.pending !== nextSummary.pending || prevSummary.in_progress !== nextSummary.in_progress || prevSummary.completed !== nextSummary.completed || prevSummary.cancelled !== nextSummary.cancelled) {
    return false;
  }
  if (prevProps.data.todos.length !== nextProps.data.todos.length) {
    return false;
  }
  for (var i = 0; i < prevProps.data.todos.length; i++) {
    var prevTodo = prevProps.data.todos[i];
    var nextTodo = nextProps.data.todos[i];
    if (prevTodo.id !== nextTodo.id || prevTodo.content !== nextTodo.content || prevTodo.status !== nextTodo.status) {
      return false;
    }
  }
  return true;
};
var TodoListWidget = function TodoListWidget(_ref) {
  var data = _ref.data;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  if (!isValidTodoData(data)) {
    return null;
  }
  var todos = data.todos,
    status_summary = data.status_summary,
    title = data.title;
  var headerTitle = getHeaderTitle(todos, status_summary, title);
  var tasksRemaining = getTasksRemaining(status_summary);
  var allCompleted = isAllTasksCompleted(status_summary);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.Collapsible, {
    open: isExpanded,
    onOpenChange: setIsExpanded,
    asChild: true,
    "data-sentry-element": "Collapsible",
    "data-sentry-component": "TodoListWidget",
    "data-sentry-source-file": "TodoListWidget.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
      size: "sm",
      className: "my-1 max-w-[85%]",
      "data-sentry-element": "Card",
      "data-sentry-source-file": "TodoListWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardHeader, {
        "data-sentry-element": "CardHeader",
        "data-sentry-source-file": "TodoListWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.CollapsibleTrigger, {
          asChild: true,
          "data-sentry-element": "CollapsibleTrigger",
          "data-sentry-source-file": "TodoListWidget.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.Item, {
            size: "xs",
            asChild: true,
            "data-sentry-element": "Item",
            "data-sentry-source-file": "TodoListWidget.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              type: "button",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
                variant: "icon",
                "data-sentry-element": "ItemMedia",
                "data-sentry-source-file": "TodoListWidget.tsx",
                children: isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {})
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemContent, {
                "data-sentry-element": "ItemContent",
                "data-sentry-source-file": "TodoListWidget.tsx",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
                  "data-sentry-element": "ItemTitle",
                  "data-sentry-source-file": "TodoListWidget.tsx",
                  children: headerTitle
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
                "data-sentry-element": "ItemActions",
                "data-sentry-source-file": "TodoListWidget.tsx",
                children: allCompleted ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
                  className: "text-success"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: "text-xs text-muted-foreground",
                  children: [tasksRemaining, " task", tasksRemaining !== 1 ? "s" : "", " left"]
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.CollapsibleContent, {
        asChild: true,
        "data-sentry-element": "CollapsibleContent",
        "data-sentry-source-file": "TodoListWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
          className: "max-h-100 overflow-y-auto",
          "data-sentry-element": "CardContent",
          "data-sentry-source-file": "TodoListWidget.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemGroup, {
            "data-sentry-element": "ItemGroup",
            "data-sentry-source-file": "TodoListWidget.tsx",
            children: todos.map(function (todo, index) {
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
                size: "xs",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
                  variant: "icon",
                  children: getStatusIcon(todo.status)
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemContent, {
                  className: (0, _utils.cn)((todo.status === "completed" || todo.status === "cancelled") && "line-through opacity-70"),
                  children: todo.content
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
                    variant: todo.status === "completed" ? "success" : "secondary",
                    children: todo.status.replace("_", " ")
                  })
                })]
              }, "".concat(todo.id, "-").concat(index));
            })
          })
        })
      })]
    })
  });
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(TodoListWidget, areTodoListWidgetPropsEqual);